import React, { useEffect, useState, useCallback, useRef } from "react";
import CustomHeading from "../../components/common/CustomHeading";
import {
  formatNumber,
  getIcons,
  getNumericValue,
} from "../../components/Constant/Constant";
import { FaMapLocationDot } from "react-icons/fa6";
import { useNavigate } from "react-router-dom";
import CustomSuccessModel from "../Custom/CustomSuccessModel";
import Header from "../Header/Header";
import CustomTable from "../Custom/CustomTable";
import ProspectPropertyService from "../Service/ProspectPropertyService";
import {
  GoogleMap,
  LoadScript,
  Marker,
  InfoWindow,
  useJsApiLoader,
} from "@react-google-maps/api";
import { mapLoaderConfig } from "../../GeoLocationCompoents/Services/mapLoaderConfig";
import PropertiesSelectingModel from "../PropertyTypeModel/PropertiesSelectingModel";
import RoughFilter from "./RoughFilter";
import RoughPropertyService from "../Service/RoughPropertyService";
import ConfirmationModal from "../../components/shareableContainer/ConfirmationModal";
import SittingService from "../Service/SittingService";

import { userUid } from "../../utils/storage";
import {
  showErrorToast,
  showSuccessToast,
} from "../../components/Constant/Notification";
import { formatDate } from "../../utils/dateFormatter";
import { HiLogout } from "react-icons/hi";
import ReusableSittingForm from "../OverallSittingManagement/ReusableSittingForm";
import { ToastContainer } from "react-toastify";
import CustomChip from "../../components/common/CustomChip";
const RoughdraftPage = () => {
  const icons = getIcons();
  const navigate = useNavigate();

  const [toggle, setToggle] = useState(false);
  const [successModel, setSuccessModel] = useState(false);
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [totalRecords, setTotalRecords] = useState(0);
  const [nextPageToken, setNextPageToken] = useState(null);
  const [prevPageToken, setPrevPageToken] = useState(null);
  const [hasMoreLeads, setHasMoreLeads] = useState(false);
  const [selected, setSelected] = useState(null);
  const [isOpenPropertyTypeModel, setIsOpenPropertyTypeModel] = useState(false);
  const [filterOpen, setFilterOpen] = useState(false);
  const [mapData, setMapData] = useState([]);
  const [dashboardCount, setDashboardCount] = useState({});
  const { isLoaded } = useJsApiLoader(mapLoaderConfig);
  const [selectedProperty, setSelectedProperty] = useState(null);

  // Pagination cache to store API responses
  const [paginationCache, setPaginationCache] = useState(new Map());
  const [pageTokens, setPageTokens] = useState([""]); // Array to store tokens for each page
  const [filterData, setFilterData] = useState({
    location: null,
    propertyType: null,
    propertySource: null,
    startDate: "",
    endDate: "",
  });
  const [isRemovingFilter, setIsRemovingFilter] = useState(false);

  const fetchMapData = async () => {
    try {
      const response = await RoughPropertyService.getPropertyMapPoints();
      setMapData(response?.data?.geoPoints || []);
    } catch (error) {
      console.error("Error fetching map data:", error);
    }
  };
  useEffect(() => {
    fetchMapData();
  }, []);

  const isFirstRender = useRef(true);

  // Separate useEffect for search and pagination changes only
  useEffect(() => {
    let delayTimer;

    const triggerFetch = () => {
      setCurrentPage(1);
      clearPaginationCache();
      fetchData("next", "", 1, filterData);
    };

    // Skip duplicate call on very first render
    if (isFirstRender.current) {
      isFirstRender.current = false;
      triggerFetch(); // call only once at initial load
      return;
    }

    // Only trigger for search query and page size changes
    if (searchQuery.length === 0 || searchQuery.length > 2) {
      delayTimer = setTimeout(() => {
        triggerFetch();
      }, 600);
    }

    return () => {
      if (delayTimer) clearTimeout(delayTimer);
    };
  }, [searchQuery, pageSize]); // Removed filterData from dependency array

  // Function to clear pagination cache
  const clearPaginationCache = () => {
    setPaginationCache(new Map());
    setPageTokens([""]);
  };

  // Function to create cache key
  const createCacheKey = (page, filters, search, size) => {
    return JSON.stringify({
      page,
      search,
      size,
      location: filters.location?.value || null,
      propertyType: filters.propertyType?.value || null,
      propertySource: filters.propertySource?.value || null,
      startDate: filters.startDate,
      endDate: filters.endDate,
    });
  };

  const [showSittingForm, setShowSittingForm] = useState(false);
  const [editingSitting, setEditingSitting] = useState(null);
  const [formData, setFormData] = useState({
    stage: "",
    sittingTitle: "",
    sittingSpot: "",
    primarySittingPerson: "",
    secondarySittingPerson: "",
    meetingPersonType: "",
    meetingPersonName: "",
    sittingDate: "",
    sittingTime: "",
    otherNotes: "",
    status: "",
  });

  const [isProspectCreated, setIsProspectCreated] = useState(false);
  const [isConfirmed, setIsConfirmed] = useState(false);
  const [fullComeDate, setFullComeDate] = useState("");

  const fetchData = async (
    direction = "next",
    cursor = "",
    page = 1,
    filters = {}
  ) => {
    setLoading(true);

    // Create cache key for current request
    const cacheKey = createCacheKey(page, filters, searchQuery, pageSize);

    // Check if data exists in cache for previous page navigation
    if (direction === "previous" && paginationCache.has(cacheKey)) {
      const cachedData = paginationCache.get(cacheKey);
      setData(cachedData.data);
      setTotalRecords(cachedData.totalRecords);
      setNextPageToken(cachedData.nextPageToken);
      setPrevPageToken(cachedData.prevPageToken);
      setHasMoreLeads(cachedData.hasMoreLeads);
      setDashboardCount(cachedData.dashboardCount);
      setLoading(false);
      return;
    }

    try {
      const body = {
        isRoughDraft: true,
        searchKey: searchQuery,
        limit: pageSize,
        startAfter: cursor,
        direction,
        // propertyEnterDate: filters.startDate && filters.endDate ? {
        //   startDate: filters.startDate,
        //   endDate: filters.endDate
        // } : null,
        location: filters.location?.value || null,
        //propertyType: filters.propertyType?.value || null,
        propertySourceBy: filters.propertySource?.value || null,
        endBefore: "",
      };

      const response = await RoughPropertyService.getRoughProperties(body);

      const responseData = response?.data;
      const fetchedData = {
        data: responseData?.data || [],
        totalRecords: responseData?.data?.length || 0,
        nextPageToken: responseData?.pagination?.next || null,
        prevPageToken: responseData?.pagination?.previous || null,
        hasMoreLeads: !!responseData?.pagination?.hasNext,
        dashboardCount: responseData?.stageCounts || {},
      };

      // Update state
      setData(fetchedData.data);
      setTotalRecords(fetchedData.totalRecords);
      setNextPageToken(fetchedData.nextPageToken);
      setPrevPageToken(fetchedData.prevPageToken);
      setHasMoreLeads(fetchedData.hasMoreLeads);
      setDashboardCount(fetchedData.dashboardCount);

      // Cache the response for future use
      setPaginationCache((prev) => {
        const newCache = new Map(prev);
        newCache.set(cacheKey, fetchedData);
        return newCache;
      });

      // Update page tokens array for navigation
      if (direction === "next" && fetchedData.nextPageToken) {
        setPageTokens((prev) => {
          const newTokens = [...prev];
          if (newTokens.length <= page) {
            newTokens[page] = fetchedData.nextPageToken;
          }
          return newTokens;
        });
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleSearchLead = () => {
    setCurrentPage(1);
    clearPaginationCache(); // Clear cache when searching
    fetchData("next", "", 1, filterData);
  };

  const handlePageChange = (token, direction) => {
    if (direction === "size") {
      setPageSize(Number(token));
      setCurrentPage(1);
      clearPaginationCache(); // Clear cache when page size changes
      fetchData("next", "", 1, filterData);
    } else if (direction === "next") {
      const nextPage = currentPage + 1;
      setCurrentPage(nextPage);
      fetchData("next", token, nextPage, filterData);
    } else if (direction === "previous") {
      const prevPage = Math.max(currentPage - 1, 1);
      setCurrentPage(prevPage);

      // Use the appropriate token for the previous page
      const prevToken = pageTokens[prevPage - 1] || "";
      fetchData("previous", prevToken, prevPage, filterData);
    }
  };

  const handleValidation = () => {
    if (!formData.sittingTitle?.trim()) {
      showErrorToast("Sitting Title is required");
      return false;
    }
    if (!formData.sittingDate) {
      showErrorToast("Sitting Date is required");
      return false;
    }
    if (!formData.sittingTime) {
      showErrorToast("Sitting Time is required");
      return false;
    }
    if (!formData.sittingSpot?.trim()) {
      showErrorToast("Sitting Spot is required");
      return false;
    }
    if (!formData.primarySittingPerson) {
      showErrorToast("Primary Sitting Person is required");
      return false;
    }

    return true;
  };
  const handleFormSubmit = async (status) => {
    if (!handleValidation()) {
      return;
    }
    try {
      const body = {
        propertyId: selectedProperty?.id,
        nextStage: "sitting",
        sittingData: {
          title: formData.sittingTitle,
          sittingDate: formData.sittingDate,
          sittingTime: formData.sittingTime,
          location: formData.sittingSpot,
          primarySittingPerson: formData.primarySittingPerson?.value,
          secondarySittingPerson: formData.secondarySittingPerson?.value,
          meetingPersonType: formData.meetingPersonType,
          meetingPersonName: formData.meetingPersonName,
          notes: formData.otherNotes,
          createdById: userUid,
        },
        modifiedById: userUid,
      };

      const response = await SittingService.moveToNextStage(body);
      const newSitting = response.data;

      if (newSitting) {
        showSuccessToast(newSitting?.message || "Sitting created successfully");
        clearPaginationCache(); // Clear cache when data is updated
        fetchData("next", "", 1, filterData);
        setShowSittingForm(false);
      }
    } catch (error) {
      console.error("Error creating sitting:", error);
    }
    setShowSittingForm(false);
  };

  const handleFormChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleMoveToProspect = async () => {
    try {
      const body = {
        propertyId: selectedProperty?.id,
        nextStage: "prospect",
        modifiedById: userUid,
        documentCameDate: formatDate(fullComeDate),
      };
      const response = await SittingService.moveToNextStage(body);
      const newSitting = response.data;

      if (newSitting) {
        showSuccessToast(newSitting?.message || "Sitting created successfully");
        clearPaginationCache(); // Clear cache when data is updated
        fetchData("next", "", 1, filterData);
        setIsProspectCreated(false);
      }
    } catch (error) {
      console.error("Error creating sitting:", error);
    }
  };

  const handleMoveToConfirm = async () => {
    try {
      const body = {
        propertyId: selectedProperty?.id,
        nextStage: "confirm_list",
        modifiedById: userUid,
        documentCameDate: formatDate(fullComeDate),
      };
      const response = await SittingService.moveToNextStage(body);
      const newSitting = response.data;

      if (newSitting) {
        showSuccessToast(newSitting?.message || "Sitting created successfully");
        clearPaginationCache(); // Clear cache when data is updated
        fetchData("next", "", 1, filterData);
        setIsConfirmed(false);
      }
    } catch (error) {
      console.error("Error creating sitting:", error);
    }
  };
  const LeadDashboradCount = [
    {
      label: "Over all",
      count: dashboardCount?.["Overall"] || 0,
      bgColor: "bg-[#9CE0C5]",
      icon: icons?.AllLeadIcon,
    },
    {
      label: "Rough Draft Stage 1",
      count: dashboardCount?.["Rough Draft"] || 0,
      bgColor: "bg-[#9CE0C2]",
      icon: icons?.AllLeadIcon,
    },
    {
      label: "In Sitting",
      count: dashboardCount?.["In Sitting"] || 0,
      bgColor: "bg-[#77C1A0]",
      icon: icons?.Unassigned,
    },
    {
      label: "In Prospect",
      count: dashboardCount?.["In Prospect"] || 0,
      bgColor: "bg-[#D3EEFF]",
      icon: icons?.Unassigned,
    },
    {
      label: "In Confirm List",
      count: dashboardCount?.["In Confirm List"] || 0,
      bgColor: "bg-[#D3EEFF]",
      icon: icons?.Fresh,
    },
  ];

  const handleNavigate = (record) => {
    const routeMap = {
      "Resale Plot": "/procurement-raughDraft/resale-plot",
      "Acres and Cents": "/procurement-raughDraft/acres-and-cents",
    };

    const path =
      routeMap[record.propertyType?.name] ||
      "/procurement-raughDraft/property-info";

    navigate(path, {
      state: {
        propertyName: record.name,
        propertyId: record.id,
        propertyTypeName: record.propertyType?.name || "",
        propertyStage: record.stage || "",
      },
    });
  };

  const stageLabels = {
    "Rough Draft": "Move to Sitting",
    "In Sitting": "Move to Prospect",
    "In Prospect": "Move to Confirm List",
    "In Confirm List": "In Confirm List",
  };

  const columns = [
    {
      key: "name",
      title: "Property Name",
      render: (text, record) => (
        <div
          onClick={() => handleNavigate(record)}
          title={text}
          className="text-blue-500 line-clamp-2 capitalize truncate cursor-pointer text-center"
        >
          {text || "N/A"}
        </div>
      ),
    },
    {
      key: "overallArea",
      title: "Overall Area (Sq.ft)",
      render: (_, row) => (
        <div className="text-center">
          {row.overAllSqft ? `${row.overAllSqft} Sq.ft` : "N/A"}
        </div>
      ),
    },
    {
      key: "location",
      title: "Location",
      render: (_, record) => (
        <div className="text-center">
          <div className="font-medium line-clamp-2 truncate text-wrap text-gray-800">
            {record?.location?.name || "N/A"}
          </div>
          {record?.locationLatitude != null &&
            record?.locationLongitude != null && (
              <button
                onClick={() => {
                  setToggle(true);
                  setSelected({
                    ...record,
                    coordinates: `${record.locationLatitude},${record.locationLongitude}`,
                  });
                  const mapElement = document.querySelector(".map-container");
                  if (mapElement) {
                    mapElement.scrollIntoView({ behavior: "smooth" });
                  }
                }}
                className="text-xs w-fit bg-blue-100 text-blue-600 px-2 py-1 rounded-full mt-1 hover:bg-blue-200 transition-colors"
              >
                View on Map
              </button>
            )}
        </div>
      ),
    },
    {
      key: "stage",
      title: "Stage",
      render: (_, record) => (
        <div className="text-center">
          <span className="px-2 py-1 text-xs rounded-full bg-blue-100 text-blue-800">
            {record?.stage || "N/A"}
          </span>
        </div>
      ),
    },
    {
      key: "propertyEnteredDate",
      title: "Property Entered Date",
      render: (_, record) => {
        const daysAgo = record?.daysSinceEntered;
        const dayLabel =
          daysAgo != null
            ? `${daysAgo} ${daysAgo > 1 ? "Days" : "Day"} ago`
            : "";

        return (
          <div className="text-center">
            <div className="font-medium text-gray-800">
             {record?.propertyEnteredDate || "N/A"}
            </div>
            {dayLabel && (
              <div className="text-xs bg-orange-50 border border-orange-500 rounded-full px-2 py-1 text-orange-600 mt-1">
                {dayLabel}
              </div>
            )}
          </div>
        );
      },
    },
    {
      key: "propertySourcedBy",
      title: "Property Sourced By",
      render: (_, record) => (
        <div className="text-center space-y-1">
          <div className="text-sm text-gray-800 truncate">
            {record?.primarySourcedBy?.name ||
              record?.propertySourceBy ||
              "N/A"}{" "}
            ({record?.primarySourcedBy?.role || "N/A"})
          </div>
          {record?.secondarySourcedBy?.name && (
            <div className="text-sm text-gray-800 truncate">
              {record.secondarySourcedBy.name} (
              {record?.secondarySourcedBy?.role || "N/A"})
            </div>
          )}
        </div>
      ),
    },
    {
      key: "sitting",
      title: "Sitting",
      render: (_, record) => (
        <div className="text-center">
          {record?.stage !== "Rough Draft" ? (
            <div className="grid grid-cols-2 text-nowrap gap-2 text-[11px] text-center">
              <div className="bg-orange-100 border border-orange-500 rounded-full text-orange-600 px-2">
                No Update: {record?.sittingStatusCounts?.noUpdate ?? 0}
              </div>
              <div className="bg-blue-100 border border-blue-500 rounded-full text-blue-600 px-2">
                Upcoming: {record?.sittingStatusCounts?.upcoming ?? 0}
              </div>
              <div className="bg-green-100 border border-green-500 rounded-full text-green-600 px-2">
                Completed: {record?.sittingStatusCounts?.completed ?? 0}
              </div>
              <div className="bg-red-100 border border-red-500 rounded-full text-red-600 px-2">
                Cancelled: {record?.sittingStatusCounts?.cancelled ?? 0}
              </div>
            </div>
          ) : (
            <span className="text-xs bg-gray-200 text-gray-800 px-2 py-1 rounded-full">
              Not Moved to Sitting
            </span>
          )}
        </div>
      ),
    },
    {
      key: "action",
      title: "Action",
      render: (_, record) => (
        <div className="flex justify-center">
          <button
            onClick={() => {
              setSelectedProperty(record);
              if (record.stage === "Rough Draft") {
                setShowSittingForm(true);
                return;
              }
              if (record.stage === "In Sitting") {
                setIsProspectCreated(true);
                return;
              }
              if (record.stage === "In Prospect") {
                setIsConfirmed(true);
                return;
              }
            }}
            className="flex items-center text-nowrap gap-2 border border-blue-500 bg-blue-100 text-blue-500 rounded-full px-3 py-1 text-sm hover:bg-blue-200 transition-colors"
          >
            {record.stage !== "In Confirm List" && (
              <HiLogout className="text-blue-500" />
            )}
            {stageLabels[record.stage] || "N/A"}
          </button>
        </div>
      ),
    },
  ];

  const center = {
    lat: 12.97,
    lng: 80.15,
  };

  const handleRemove = (key) => {
    // Prevent multiple rapid calls
    if (isRemovingFilter) return;

    setIsRemovingFilter(true);

    const newFilterData = { ...filterData };

    if (key === "location") {
      newFilterData.location = null;
    } else if (key === "propertyType") {
      newFilterData.propertyType = null;
    } else if (key === "propertySource") {
      newFilterData.propertySource = null;
    } else if (key === "dateRange") {
      newFilterData.startDate = "";
      newFilterData.endDate = "";
    }

    // Update filter data and clear cache once
    setFilterData(newFilterData);
    setCurrentPage(1);
    clearPaginationCache();

    // Fetch data with new filters and reset the flag
    fetchData("next", "", 1, newFilterData).finally(() => {
      setIsRemovingFilter(false);
    });
  };

  return (
    <div className="bg-appGrayBackground min-h-screen pb-14">
      <Header />
      <ToastContainer />
      <div className="pt-28 px-6">
        <div className="flex items-center justify-between">
          <CustomHeading title="Rough Draft" />
          <button
            onClick={() => {
              setIsOpenPropertyTypeModel(true);
            }}
            className="text-white text-center p-3 font-medium rounded-[10px] bg-customGreen"
          >
            Add Prospect Property
          </button>
        </div>

        {/* Dashboard Cards */}
        <div className="grid grid-cols-4 mt-4 xl:grid-cols-7 gap-4 pt-[36px] pb-[28px]">
          {LeadDashboradCount.map((item, index) => (
            <div key={index} className="w-full flip-card">
              <div className="cursor-pointer rounded-2xl h-full min-h-[120px]">
                <div
                  className={`${item?.bgColor} flip-card-front rounded-2xl p-4 h-full flex flex-col justify-between`}
                >
                  <div className="text-xl font-medium mb-2">
                    {formatNumber(getNumericValue(item?.count))}
                  </div>
                  <div className="flex items-center justify-between">
                    <div className="text-[15px] font-medium">{item?.label}</div>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="mb-4">
          {(filterData.location ||
            filterData.propertyType ||
            filterData.propertySource ||
            (filterData.startDate && filterData.endDate)) && (
            <div className="flex items-center gap-3 flex-wrap">
              <span className="text-sm font-medium text-gray-700">
                Applied Filters:
              </span>

              {filterData.location && (
                <CustomChip
                  value={filterData.location.label}
                  onRemove={() => handleRemove("location")}
                />
              )}

              {filterData.propertyType && (
                <CustomChip
                  value={filterData.propertyType.label}
                  onRemove={() => handleRemove("propertyType")}
                />
              )}

              {filterData.propertySource && (
                <CustomChip
                  value={filterData.propertySource.label}
                  onRemove={() => handleRemove("propertySource")}
                />
              )}

              {filterData.startDate && filterData.endDate && (
                <CustomChip
                  value={`Date: ${filterData.startDate} to ${filterData.endDate}`}
                  onRemove={() => handleRemove("dateRange")}
                />
              )}
            </div>
          )}
        </div>

        {/* Property Table */}
        <CustomTable
          disPlay={false}
          columns={columns}
          data={data}
          placeholder={"Search Property Name..."}
          searchQuery={searchQuery}
          setSearchQuery={setSearchQuery}
          handleSearchLead={handleSearchLead}
          loading={loading}
          pagination={true}
          onPageChange={handlePageChange}
          currentPage={currentPage}
          pageSize={pageSize}
          totalRecords={totalRecords}
          nextPageToken={nextPageToken}
          prevPageToken={prevPageToken}
          hasMoreLeads={hasMoreLeads}
          setToggel={setToggle}
          handleFilter={() => setFilterOpen(true)}
          isFilter={toggle ? false : true}
          toggel={toggle}
          children={
            <div className="grid grid-cols-1 md:grid-cols-12 gap-6 p-3 w-full">
              {/* Interactive Google Map */}
              <div className="h-[500px] rounded-md overflow-hidden border col-span-8 map-container">
                {!isLoaded ? (
                  <div className="flex items-center justify-center h-full">
                    Loading map...
                  </div>
                ) : (
                  <GoogleMap
                    mapContainerStyle={{ width: "100%", height: "100%" }}
                    center={
                      selected
                        ? {
                            lat: parseFloat(selected.coordinates.split(",")[0]),
                            lng: parseFloat(selected.coordinates.split(",")[1]),
                          }
                        : center
                    }
                    zoom={selected ? 15 : 11}
                  >
                    {mapData.map((property) => {
                      const [lat, lng] = property.coordinates
                        .split(",")
                        .map(Number);
                      return (
                        <Marker
                          key={property.id}
                          position={{ lat, lng }}
                          onMouseOver={() => setSelected(property)}
                          onClick={() => setSelected(property)}
                          icon={
                            selected && selected.id === property.id
                              ? {
                                  url:
                                    "data:image/svg+xml;charset=UTF-8," +
                                    encodeURIComponent(`
                              <svg width="30" height="30" viewBox="0 0 30 30" xmlns="http://www.w3.org/2000/svg">
                                <circle cx="15" cy="15" r="12" fill="#10B981" stroke="#ffffff" stroke-width="3"/>
                              </svg>
                            `),
                                  scaledSize: new window.google.maps.Size(
                                    30,
                                    30
                                  ),
                                }
                              : undefined
                          }
                        />
                      );
                    })}

                    {data
                      .filter(
                        (property) =>
                          property.locationLatitude &&
                          property.locationLongitude
                      )
                      .map((property) => {
                        const lat = parseFloat(property.locationLatitude);
                        const lng = parseFloat(property.locationLongitude);
                        return (
                          <Marker
                            key={`table-${property.id}`}
                            position={{ lat, lng }}
                            onMouseOver={() =>
                              setSelected({
                                ...property,
                                coordinates: `${lat},${lng}`,
                              })
                            }
                            onClick={() =>
                              setSelected({
                                ...property,
                                coordinates: `${lat},${lng}`,
                              })
                            }
                            icon={{
                              url:
                                "data:image/svg+xml;charset=UTF-8," +
                                encodeURIComponent(`
                                <svg width="25" height="25" viewBox="0 0 25 25" xmlns="http://www.w3.org/2000/svg">
                                  <circle cx="12.5" cy="12.5" r="10" fill="#3B82F6" stroke="#ffffff" stroke-width="2"/>
                                </svg>
                              `),
                              scaledSize: new window.google.maps.Size(25, 25),
                            }}
                          />
                        );
                      })}

                    {selected && (
                      <InfoWindow
                        position={{
                          lat: parseFloat(selected.coordinates.split(",")[0]),
                          lng: parseFloat(selected.coordinates.split(",")[1]),
                        }}
                        onCloseClick={() => setSelected(null)}
                      >
                        <div className="p-3 max-w-xs">
                          <h4 className="font-bold text-lg mb-2">
                            {selected.name}
                          </h4>
                          <div className="space-y-1 text-sm">
                            <p>
                              <strong>Area:</strong>{" "}
                              {selected.overallArea || "N/A"} Sq.ft
                            </p>
                            <p>
                              <strong>Location:</strong>{" "}
                              {selected.location?.name || selected.location}
                            </p>
                          </div>
                        </div>
                      </InfoWindow>
                    )}
                  </GoogleMap>
                )}
              </div>

              {/* Property List */}
              <div className="col-span-4 h-[500px] rounded-md overflow-y-auto p-1">
                <div className="mb-4">
                  <h3 className="font-semibold text-lg text-gray-800 mb-2">
                    Properties on Map
                  </h3>
                  <p className="text-sm text-gray-600">
                    Click on any property to view on map
                  </p>
                </div>

                {mapData.map((list) => (
                  <div
                    key={`map-${list.id}`}
                    className={`p-3 mb-3 border rounded-md cursor-pointer transition-colors ${
                      selected && selected.id === list.id
                        ? "border-green-500 bg-green-50"
                        : "border-slate-200 hover:bg-gray-50"
                    }`}
                    onClick={() => setSelected(list)}
                  >
                    <div className="flex flex-col gap-2">
                      <div className="text-blue-500 text-[16px] capitalize truncate cursor-pointer font-medium">
                        {list?.name}
                      </div>
                      <div className="flex items-center gap-2">
                        <div className="text-[12px] text-gray-600">
                          Area: {list?.overallArea || "N/A"} Sq.ft
                        </div>
                      </div>
                      <div className="flex items-center gap-2">
                        <FaMapLocationDot className="text-customGreen" />
                        <div className="text-[12px] text-gray-600">
                          {list?.location?.name || list?.location}
                        </div>
                      </div>
                    </div>
                  </div>
                ))}

                {/* {data.filter(property => property.locationLatitude && property.locationLongitude)
                  .map((list) => (
                    <div
                      key={`table-map-${list.id}`}
                      className={`p-3 mb-3 border rounded-md cursor-pointer transition-colors ${
                        selected && selected.id === list.id 
                          ? 'border-blue-500 bg-blue-50' 
                          : 'border-slate-200 hover:bg-gray-50'
                      }`}
                      onClick={() => setSelected({
                        ...list,
                        coordinates: `${list.locationLatitude},${list.locationLongitude}`
                      })}
                    >
                      <div className="flex flex-col gap-2">
                        <div className="text-blue-500 text-[16px] capitalize truncate cursor-pointer font-medium">
                          {list?.name}
                        </div>
                        <div className="flex items-center gap-2">
                          <div className="text-[12px] text-gray-600">
                            Area: {list?.overallArea || 'N/A'} Sq.ft
                          </div>
                        </div>
                        <div className="flex items-center gap-2">
                          <FaMapLocationDot className="text-customGreen" />
                          <div className="text-[12px] text-gray-600">
                            {list?.location?.name || 'N/A'}
                          </div>
                        </div>
                        <div className="text-xs bg-blue-100 text-blue-600 px-2 py-1 rounded-full w-fit">
                          From Table Data
                        </div>
                      </div>
                    </div>
                  ))} */}
              </div>
            </div>
          }
        />
      </div>

      <CustomSuccessModel
        isOpen={successModel}
        onClose={() => {
          setSuccessModel(false);
        }}
        title={"Property Added Successfully"}
      />
      <PropertiesSelectingModel
        isOpen={isOpenPropertyTypeModel}
        close={() => setIsOpenPropertyTypeModel(false)}
        accessType={"RoughDraft"}
      />
      <RoughFilter
        isOpen={filterOpen}
        onClose={() => setFilterOpen(false)}
        currentFilters={filterData}
        onApplyFilters={(filters) => {
          setFilterData(filters);
          setCurrentPage(1);
          clearPaginationCache();
          fetchData("next", "", 1, filters);
        }}
      />
      <ReusableSittingForm
        visible={showSittingForm}
        editingSitting={editingSitting}
        setFormData={setFormData}
        onHide={() => setShowSittingForm(false)}
        onSubmit={handleFormSubmit}
        formData={formData}
        onChange={handleFormChange}
        title="Sitting"
        sidebarWidth="600px"
        showAdvancedButtons={true}
        customButtonLogic={(formData) => {
          const isUpcomingOrNoUpdate =
            formData?.isCompleted === "Up Coming" ||
            formData?.isCompleted === "No Update";

          const isNotCompletedOrCancelled =
            formData.isCompleted !== "COMPLETED" &&
            formData.isCompleted !== "CANCELLED";

          const canShowAdvancedButtons =
            formData.stage !== "completed" && formData.stage !== "cancelled";

          return {
            showPrimaryButton:
              (isUpcomingOrNoUpdate && canShowAdvancedButtons) ||
              isNotCompletedOrCancelled,
            showCompletedButton: isUpcomingOrNoUpdate && canShowAdvancedButtons,
            showCancelButton: isUpcomingOrNoUpdate && canShowAdvancedButtons,
          };
        }}
      />
      <ConfirmationModal
        showModal={isProspectCreated}
        title="Are You Sure ?"
        message="Are you sure you want to move to the In Prospect Stage?"
        additionalProp={false}
        content={
          <>
            <div>
              <p className="text-sm text-gray-600">
                Select the Full Doc Came date for this property
              </p>
              <input
                type="date"
                name="fullDocCameDate"
                value={fullComeDate}
                onChange={(e) => {
                  setFullComeDate(e.target.value);
                }}
                className="mt-2 p-2 border border-gray-300 rounded-md w-full"
              />
            </div>
            <div className="flex justify-center gap-3 ">
              <button
                onClick={() => {
                  setIsProspectCreated(false);
                  setIsConfirmed(false);
                }}
                className="mt-4 mr-2 px-4 py-2 bg-gray-300 text-gray-700 rounded-md "
              >
                Cancel
              </button>
              <button
                disabled={!fullComeDate}
                onClick={() => {
                  handleMoveToProspect();
                }}
                className={`mt-4 px-4 py-2 text-white rounded-md ${
                  fullComeDate
                    ? "bg-customGreen cursor-pointer"
                    : "bg-gray-400 cursor-not-allowed"
                }`}
              >
                Confirm
              </button>
            </div>
          </>
        }
      />

      <ConfirmationModal
        showModal={isConfirmed}
        title="Are You Sure ?"
        message="Are you sure you want to move to the In Confirmation Stage?"
        additionalProp={false}
        content={
          <>
            <div>
              <p className="text-sm text-gray-600">
                Select the Full Doc Came date for this property
              </p>
              <input
                type="date"
                name="fullDocCameDate"
                value={fullComeDate}
                onChange={(e) => {
                  setFullComeDate(e.target.value);
                }}
                className="mt-2 p-2 border border-gray-300 rounded-md w-full"
              />
            </div>
            <div className="flex justify-center gap-3 ">
              <button
                onClick={() => {
                  setIsProspectCreated(false);
                  setIsConfirmed(false);
                }}
                className="mt-4 mr-2 px-4 py-2 bg-gray-300 text-gray-700 rounded-md "
              >
                Cancel
              </button>
              <button
                disabled={!fullComeDate}
                onClick={() => {
                  handleMoveToConfirm();
                }}
                className={`mt-4 px-4 py-2 text-white rounded-md ${
                  fullComeDate
                    ? "bg-customGreen cursor-pointer"
                    : "bg-gray-400 cursor-not-allowed"
                }`}
              >
                Confirm
              </button>
            </div>
          </>
        }
      />
    </div>
  );
};

export default RoughdraftPage;
